(function () {
  'use strict';

  var STORAGE_KEY = 'lrGridDensity';

  function applyDensity(el, density) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.toggle('lr-collection-grid--comfortable', density === 'comfortable');
    }
    el.querySelectorAll('.lr-grid-density__button').forEach(function (button) {
      var isActive = button.dataset.density === density;
      button.classList.toggle('lr-grid-density__button--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function readStoredDensity() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function storeDensity(density) {
    try {
      window.localStorage.setItem(STORAGE_KEY, density);
    } catch (e) {}
  }

  class LrGridDensity extends HTMLElement {
    connectedCallback() {
      this.density = readStoredDensity() === 'comfortable' ? 'comfortable' : 'compact';
      applyDensity(this, this.density);

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      // The product grid is re-rendered from scratch by facet filtering
      // (AJAX swap of #ProductGridContainer), which would otherwise drop
      // the density class the user picked. Reapply it whenever that
      // happens.
      var container = document.getElementById('ProductGridContainer');
      if (container && 'MutationObserver' in window) {
        this.observer = new MutationObserver(function () {
          applyDensity(this, this.density);
        }.bind(this));
        this.observer.observe(container, { childList: true, subtree: false });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onClick(event) {
      var button = event.target.closest('.lr-grid-density__button');
      if (!button || !this.contains(button)) return;
      var density = button.dataset.density === 'comfortable' ? 'comfortable' : 'compact';
      if (density === this.density) return;
      this.density = density;
      applyDensity(this, density);
      storeDensity(density);
    }
  }

  if (!customElements.get('lr-grid-density')) {
    customElements.define('lr-grid-density', LrGridDensity);
  }
})();
